namespace e5 {
    export interface AbstractLoaderOptions {
        cache?: boolean;
    }

    export abstract class AbstractLoader<Response, Options extends AbstractLoaderOptions> implements Promise<Response>{
        [Symbol.toStringTag]: string;

        protected _onProgress = e5.Signal.create<[number, number, ProgressEvent]>();
        protected _onFinally = e5.Signal.create<[Response | RejectReason]>();

        public readonly promise: Promise<Response>;

        public readonly url: string;

        protected _options: Options;

        private _resolve: (image: Response) => void
        private _reject: (reason: RejectReason) => void;

        constructor(url: string, options: Options = null) {

            this._options = ObjectUtil.extend(this.defaultOptions(), (options || {}) as any);
            this.url = url;
            if (this._options.cache !== undefined && !this._options.cache) {
                this.url = Url.params.set("_", Date.now() + "");
            }

            this.promise = new Promise<Response>(
                (res, rej) => {
                    this._resolve = res;
                    this._reject = rej;
                }
            );
        }

        protected resolve(result: Response): void {
            this._resolve(result);
            this._onFinally.dispatch(result);
            this.finish();
        }

        protected reject(reason: any): void {
            var o: RejectReason = { reason: reason, loader: this };
            this._reject(o);
            this._onFinally.dispatch(o);
            this.finish();
        }

        public then<TResult1 = Response, TResult2 = never>(onfulfilled?: (value: Response) => TResult1 | PromiseLike<TResult1>, onrejected?: (reason: any) => TResult2 | PromiseLike<TResult2>): Promise<TResult1 | TResult2> {
            return this.promise.then(onfulfilled);
        }

        public catch<TResult = never>(onrejected?: (reason: RejectReason) => TResult | PromiseLike<TResult>): Promise<Response | TResult> {
            return this.promise.catch(onrejected);
        }

        //@ts-ignore
        public finally(onfinally: (response: (Response | RejectReason)) => (Response | RejectReason) | PromiseLike<Response | RejectReason>, context: any = null): Promise<Response | RejectReason> {
            return this._onFinally.promise(true).then(onfinally as any);
        }

        public cancel(reason: any = null): this {
            this.reject(reason);
            return this;
        }

        public progress(callback: (loaded: number, total: number, evt?: ProgressEvent) => void, context: any = null): this {
            if (!this._onProgress)
                return this;
            this._onProgress.add(callback, context);
            return this;
        }

        protected finish(): void {
            this._onProgress.dispose();
            this._onProgress = null;
            this._onFinally.dispose();
            this._onFinally = null;
        }

        protected abstract defaultOptions(): Options;
    }

    export interface LoaderOptionsMap {
    }

    export interface LoaderMap {
    }

    type LoaderLookup<T extends AbstractLoader<any, any>> = {
        [P in keyof LoaderMap]: new (url: string, options?: AbstractLoaderOptions) => T;
    }

    const loaders: LoaderLookup<any> = {} as any;

    export function registerLoader<T extends keyof LoaderMap>(key: T, loader: new (url: string, options?: AbstractLoaderOptions) => LoaderMap[T]): void {
        loaders[key] = loader;
    }

    export function load<T extends keyof LoaderMap>(loader: T, url: string, options: LoaderOptionsMap[T] = null): LoaderMap[T] {
        var result = new loaders[loader](url, options);
        return result;
    }

    export interface RejectReason {
        loader: AbstractLoader<any, any>;
        reason: any;
    }
}